import { fetch } from '@ixigo/shell/fetch';
import type { CreatorApplicationSubmission } from '../types';
import { SOMETHING_WENT_WRONG, toApiError } from './api-error';
import type {
	CodeAvailabilityDto,
	CreatorDetailsDto,
} from './creator-api.types';

const CREATORS_ENDPOINT = 'creator-platform/api/v1/creators';

/** Fetches the raw details response. Mapping happens outside this layer. */
export function fetchCreatorDetails(): Promise<CreatorDetailsDto> {
	return fetch.get(`${CREATORS_ENDPOINT}/details`).json<CreatorDetailsDto>();
}

/** Always 200 with `available`; a 502 means the check couldn't run. */
export function fetchCodeAvailability(
	code: string,
): Promise<CodeAvailabilityDto> {
	return fetch
		.get(`${CREATORS_ENDPOINT}/codes/availability`, { searchParams: { code } })
		.json<CodeAvailabilityDto>();
}

/**
 * 201 with the creator's new details, same shape as `fetchCreatorDetails`.
 * Rejects with an `ApiError` carrying the API's message and error code.
 */
export function postCreatorApplication(
	submission: CreatorApplicationSubmission,
): Promise<CreatorDetailsDto> {
	return fetch
		.post(`${CREATORS_ENDPOINT}/applications`, { json: submission })
		.json<CreatorDetailsDto>()
		.catch(async (error: unknown) => {
			throw await toApiError(error, SOMETHING_WENT_WRONG);
		});
}
